import { createContext } from 'react';
import { VehicleFilterParameters } from '../utils/vehicle-filter-types';

export interface BevManagerFilterCache {
  getFilters: (solutionId: string) => VehicleFilterParameters | null;
  setFilters: (solutionId: string, filters: VehicleFilterParameters) => void;
  clearFilters: () => void;
}

const BevManagerFilterContext = createContext<BevManagerFilterCache>({
  getFilters: () => null,
  setFilters: () => {
    // noop default context handler
  },
  clearFilters: () => {
    // noop default context handler
  },
});

export default BevManagerFilterContext;
